import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"
import styled from "styled-components"

import Image from "gatsby-image"
import { GatsbyImageProps } from "gatsby-image"
import { useRenderOn } from "../../../hooks/useRenderOn"

const Portrait = styled(Image)`
  object-fit: cover;
  height: 100%;
  width: 100%;
  filter: grayscale(100%);
`

interface ITargetInfo {
  left: number
  top: number
  width: number
  height: number
}

interface IPortraitWrapper {
  targetInfo: ITargetInfo
}

const PortraitWrapper = styled.div<IPortraitWrapper>`
  width: 200px;
  height: 200px;
  border-radius: 50% !important;

  overflow: hidden;
  display: none;

  &.active {
    display: inline-block;

    transform: ${({ targetInfo }: IPortraitWrapper): string =>
      `translate(${targetInfo.left + targetInfo.width / 2 - 100}px, ${
        targetInfo.top - targetInfo.height / 2
      }px)`};
  }
`

const FormerMember = styled.div`
  position: relative;
`

interface IProps {
  name: string
  firstName?: string
  portrait?: GatsbyImageProps
  teamByYearLength: number
  index: number
}

const PortraitHover = ({
  firstName,
  name,
  portrait,
  teamByYearLength,
  index,
}: IProps): JSX.Element => {
  const { lgOrUp } = useRenderOn()

  /**
   * Select portrait wrapper
   */
  const [target, setTarget] = useState<Element | null>()
  const [targetInfo, setTargetInfo] = useState<ITargetInfo>({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  })

  useEffect(() => {
    setTarget(document.querySelector("#portraitHoverWrapper"))
  }, [])

  const [inHover, setHover] = useState(false)

  const mouseEnter = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    setHover(true)

    const current = e.currentTarget
    const currentParent = current.offsetParent as HTMLDivElement

    setTargetInfo({
      left: currentParent.offsetLeft,
      top: currentParent.offsetTop,
      width: current.offsetWidth,
      height: current.offsetHeight,
    })
  }

  const mouseLeave = () => {
    setHover(false)
  }

  return (
    <FormerMember>
      <span onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
        {firstName + " " + name}
      </span>

      {lgOrUp &&
        portrait &&
        target &&
        createPortal(
          <PortraitWrapper
            className={inHover ? "active" : ""}
            targetInfo={{
              left: targetInfo.left,
              top: targetInfo.top,
              width: targetInfo.width,
              height: targetInfo.height,
            }}
          >
            <Portrait
              fluid={portrait.fluid}
              alt={firstName + " " + name}
            />
          </PortraitWrapper>,
          target
        )}

      {teamByYearLength - 1 > index && <span>, </span>}
    </FormerMember>
  )
}

export default PortraitHover
